// pages
import LoginPage from 'pages/LoginPage';
import HFHomePage from 'pages/HFHomePage';
import HFOrdersPage from 'pages/HFOrdersPage';
import HFOrderDetailsPage from 'pages/HFOrderDetailsPage';
import HFCompletedOrdersPage from 'pages/HFCompletedOrdersPage';
import HFProductionHomePage from 'pages/production/HFProductionHomePage';
import HFMyTasksPage from 'pages/HFMyTasksPage';
import HFQualityCheckPage from 'pages/HFQualityCheckPage';
import ProductionJobsPage from 'pages/ProductionJobsPage';
import ProdJobDetailsPage from 'pages/ProdJobDetailsPage';
import QualityCheckPjPage from 'pages/QualityCheckPjPage';

// urls
import {
  getHomePageUrl,
  getLoginPageUrl,
  getOrdersPageUrl,
  getOrderDetailsPageUrl,
  getCompletedOrdersPageUrl,
  getGroupedSkuPageUrl,
  getGroupedZonePageUrl,
  getProductionHomePage,
  getMyTasksPageUrl,
  getQualityCheckPageUrl,
  getProductionJobsPageUrl,
  getJobDetailsPageUrl,
  getQualityCheckPjPageUrl,
} from 'constants/AppUrls';

export const registerationRoutes = [{ path: getLoginPageUrl(), component: LoginPage }];

export const RestrictedRoutes = () => [
    {
      path: getHomePageUrl(),
      component: HFHomePage,
      exact: true,
    },
    {
      path: getOrdersPageUrl(),
      component: HFOrdersPage,
      exact: true,
    },
    {
      path: getOrderDetailsPageUrl(),
      component: HFOrderDetailsPage,
      exact: true,
    },
    {
      path: getCompletedOrdersPageUrl(),
      component: HFCompletedOrdersPage,
      exact: true,
    },
    {
      path: getGroupedSkuPageUrl(),
      component: HFOrdersPage,
      exact: true,
    },
    {
      path: getGroupedZonePageUrl(),
      component: HFOrdersPage,
      exact: true,
    },
    {
      path: getProductionHomePage(),
      component: HFProductionHomePage,
      exact: true,
    },
    {
      path: getMyTasksPageUrl(),
      component: HFMyTasksPage,
      exact: true,
    },
    {
      path: getQualityCheckPageUrl(),
      component: HFQualityCheckPage,
      exact: true,
    },
    {
      path: getProductionJobsPageUrl(),
      component: ProductionJobsPage,
      exact: true,
    },
    {
      path: getJobDetailsPageUrl(),
      component: ProdJobDetailsPage,
      exact: true,
    },
    {
      path: getQualityCheckPjPageUrl(),
      component: QualityCheckPjPage,
      exact: true,
    },
  ];
